// File: src/stores/modules/license.js
export default {
  namespaced: true,
  state: {
    buyNewOrUpgrade: 0, // 0. đơn vị chính thức, 4. dùng thử
    daysRemaining: 0,   // Số ngày còn lại
    expiredDate: null,  // Ngày hết hạn
    isExpired: false    // Trạng thái hết hạn
  },
  mutations: {
    SET_LICENSE_DATA(state, data) {
      if (data.hasOwnProperty('buyNewOrUpgrade')) {
        state.buyNewOrUpgrade = data.buyNewOrUpgrade;
      }
      
      if (data.hasOwnProperty('daysRemaining')) {
        state.daysRemaining = data.daysRemaining;
      }
      
      if (data.hasOwnProperty('expiredDate')) {
        state.expiredDate = data.expiredDate;
      }
      
      if (data.hasOwnProperty('isExpired')) {
        state.isExpired = data.isExpired;
      }
    }
  },
  getters: {
    getLicenseData: state => state
  }
}
